<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span [routerLink]="['/partner/list']" class="go-back">
      <img src="assets/images/arrow-left.svg" alt="arrow-left" />Partners List
    </span>
    <img src="assets/images/arrow-right.svg" alt="arrow-right" />
    <ng-container *ngIf="!isEdit">Add</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container> Partner
  </div>
  <form
    class="mat-form"
    [formGroup]="upsertPartnerFrom"
    (ngSubmit)="onSubmit()">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <mat-card-title>Partner Details</mat-card-title>
          <mat-divider class="position-relative mb-3"></mat-divider>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.name"
                [formControlName]="attrConstant.name.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.website"
                [formControlName]="
                  attrConstant.website.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.email"
                [formControlName]="attrConstant.email.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.mode"
                [selectOptions]="mode"
                [bindLabel]="'name'"
                [bindValue]="'value'"
                [formControlName]="attrConstant.mode.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address1"
                [formControlName]="
                  attrConstant.address1.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.address2"
                [formControlName]="
                  attrConstant.address2.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.city"
                [formControlName]="attrConstant.city.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.zip"
                [formControlName]="attrConstant.zip.key"></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.country"
                [selectOptions]="countryList | async"
                [bindLabel]="'country_name'"
                [bindValue]="'alpha3'"
                [formControlName]="attrConstant.country.key"></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.phone"
                [formControlName]="attrConstant.phone.key"></app-input-template>
            </div>
          </div>

          <mat-divider class="position-relative my-3"></mat-divider>
          <div class="row">
            <div class="col-12 form-group">
              <app-input-image-crop
                [inputData]="attrConstant.logo"
                hint="For best results, upload a rectangular (landscape) logo. After selecting an image you can crop it below."
                [formControlName]="attrConstant.logo.key"></app-input-image-crop>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <button class="btn primary-btn w-100 mt-3">Submit</button>
  </form>
</div>
